export default __webpack_public_path__ + "static/new-logo-1666f9e903042d5b61181577061abf6b.png";